

















import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import RiskResourcesService from '@/services/RiskResources';

import Welcome from '@/components/RiskResources/Welcome.vue';
import IconListingBlock from '@/components/RiskResources/IconListingBlock.vue';

@Component({
	name: 'TwoColumnGrid',
	components: {
		Welcome,
		IconListingBlock,
	},
})
export default class TwoColumnGrid extends Vue {
	@Getter('pageContent', { namespace: 'RiskResources' }) private pageContent: any;
	@Getter('pageTitle', { namespace: 'RiskResources' }) private pageTitle: any;

	private RiskResourcesService: typeof RiskResourcesService = RiskResourcesService;

	private chunk(size, data) {
		return data.reduce(
			(segments, _, index) =>
				index % size === 0 ? [...segments, data.slice(index, index + size)] : segments,
			[],
		);
	}
}
